import React from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import { BULK_UPLOAD_MESSAGES } from "../Json/BulkUploadMessages";
import { downloadBlob } from "../Utils/responseUtils";

const { result: resultMessages } = BULK_UPLOAD_MESSAGES;
const CARD_MAX_WIDTH = 420;

/**
 * Shown once an upload finishes.
 *
 * The backend reports the outcome of every row inside the result file, so the
 * screen does not restate it - the download is the result.
 */
const BulkUploadResult = ({ result }) => {
  if (!result.file) {
    return (
      <p className="text-muted text-center mt-4 mb-0">
        {result.message || resultMessages.completed}
      </p>
    );
  }

  const { blob, filename } = result.file;

  return (
    <div className="d-flex justify-content-center mt-4">
      <div
        className="border rounded-3 text-center p-4 w-100"
        style={{ maxWidth: CARD_MAX_WIDTH }}
      >
        <i className="ri-file-excel-2-line text-success fs-1 d-block" />

        <h6 className="mt-3 mb-1">{resultMessages.heading}</h6>

        <p className="text-muted font-size-12 text-truncate mb-3">{filename}</p>

        <Button color="primary" onClick={() => downloadBlob(blob, filename)}>
          <i className="ri-download-2-line me-1" />
          {resultMessages.download}
        </Button>
      </div>
    </div>
  );
};

BulkUploadResult.propTypes = {
  result: PropTypes.shape({
    message: PropTypes.string,
    file: PropTypes.shape({
      blob: PropTypes.instanceOf(Blob),
      filename: PropTypes.string,
    }),
  }).isRequired,
};

export default BulkUploadResult;
